__turbopack_context__.v({
  "title": "course-requirements-module-scss-module__AfbJoq__title",
});
